import ChatMessage from '../models/chat_message';
import { endpoints } from './apiConfig';

// Function to stream chat responses
export const streamChatResponse = async (input, threadId, onMessageCallback) => {
  try {
    const response = await fetch(endpoints.getReceptionAgentResponse, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: input, threadId: threadId || null }),
      });
  
      if (!response.body) {
        throw new Error('No response body found.');
      }

      let isFirstChunk = true;
      let buffer = ''; // Buffer to accumulate data between chunks

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
       // SSE format handling
       buffer += chunk; // Append the current chunk to the buffer
       const events = buffer.split('\n\n'); // SSE events end with double newlines
       buffer = events.pop(); // Save the last incomplete event back to the buffer

       for (const event of events) {
        if (event.startsWith('data:')) {
          const jsonData = JSON.parse(event.slice(6)); // Extract the JSON after "data: "

          if (isFirstChunk) {
            try {
              onMessageCallback(jsonData, true); // Pass as first chunk
            } catch (err) {
              console.error('Error parsing first chunk as JSON:', err);
            }
            isFirstChunk = false;
          } else {
            // Subsequent chunks are plain text
            onMessageCallback(jsonData, false); // Pass as raw text
          }
        }
      }
    //   parser.feed(chunk); // Feed the chunk to the parser
    }
  } catch (error) {
    console.error('Error streaming chat response:', error);
    throw error;
  }
};

